import { Entry } from './entry';

Entry.displayName = 'Loader';

export { Entry as Loader };
